export enum OrderStatusEnum {
    STATUS_CLIENT_REVIEW = 88467,
    STATUS_DL_AVAILABLE = 84287,
    STATUS_FINISH = 12,
}
